<div *ngIf="pageLoading1 || pageLoading2 || pageLoading3 || pageLoading4" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.Doctor_Master=='Full') {
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('type_id')}" [items]="userTypes" bindLabel="name"
				bindValue="Id" id="type_id" formControlName="type_id" placeholder="Type*" [appearance]="'outline'">
			</ng-select>
			<p *ngIf="showError('type_id')" class="text-danger">
				<span *ngIf="f.type_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.type_id.errors?.incorrect">
					{{customError.type_id}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label>Name*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
					formControlName="email" placeholder="">
				<label>Email*</label>
			</div>
			<p *ngIf="showError('email')" class="text-danger">
				<span *ngIf="f.email.errors?.required">
					Required
				</span>
				<span *ngIf="f.email.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.email.errors?.incorrect">
					{{customError.email}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="w-50 float-start">
				<ng-select [ngClass]="{'is-invalid':showError('country_code')}" [items]="countryCodes"
					bindLabel="display" bindValue="dial_code" [clearable]="true" [multiple]="false" id="country_code"
					formControlName="country_code" placeholder="Country Code*" [appearance]="'outline'">
				</ng-select>
				<p *ngIf="showError('country_code')" class="text-danger">
					<span *ngIf="f.country_code.errors?.required">
						Required
					</span>
					<span *ngIf="f.country_code.errors?.incorrect">
						{{customError.country_code}}
					</span>
				</p>
			</div>
			<div class="w-50 float-start">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('phone_number')}" id="phone_number"
						formControlName="phone_number" placeholder="">
					<label>Phone Number*</label>
				</div>
				<p *ngIf="showError('phone_number')" class="text-danger">
					<span *ngIf="f.phone_number.errors?.required">
						Required
					</span>
					<span *ngIf="f.phone_number.errors?.pattern">
						Invalid
					</span>
					<span *ngIf="f.phone_number.errors?.incorrect">
						{{customError.phone_number}}
					</span>
				</p>
			</div>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('licence_no')}" id="licence_no"
					formControlName="licence_no" placeholder="">
				<label>Licence Number</label>
			</div>
			<p *ngIf="showError('licence_no')" class="text-danger">
				<span *ngIf="f.licence_no.errors?.required">
					Required
				</span>
				<span *ngIf="f.licence_no.errors?.incorrect">
					{{customError.licence_no}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('licence_authority')}"
					id="licence_authority" formControlName="licence_authority" placeholder="">
				<label>Licence Authority</label>
			</div>
			<p *ngIf="showError('licence_authority')" class="text-danger">
				<span *ngIf="f.licence_authority.errors?.required">
					Required
				</span>
				<span *ngIf="f.licence_authority.errors?.incorrect">
					{{customError.licence_authority}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="input-group">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('licence_date')}" placeholder=""
						formControlName="licence_date" ngbDatepicker id="licence_date"
						#licence_date_picker="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
					<label>Licence date</label>
				</div>
				<button class="btn btn-outline-secondary" (click)="licence_date_picker.toggle()" type="button">
					<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
				</button>
			</div>
			<p *ngIf="showError('licence_date')" class="text-danger">
				<span *ngIf="f.licence_date.errors?.required">
					Required
				</span>
				<span *ngIf="f.licence_date.errors?.incorrect">
					{{customError.licence_date}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('dg_no')}" id="dg_no"
					formControlName="dg_no" placeholder="">
				<label>DG No.</label>
			</div>
			<p *ngIf="showError('dg_no')" class="text-danger">
				<span *ngIf="f.dg_no.errors?.required">
					Required
				</span>
				<span *ngIf="f.dg_no.errors?.incorrect">
					{{customError.dg_no}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('qualification')}" id="qualification"
					formControlName="qualification" placeholder="">
				<label>Qualification</label>
			</div>
			<p *ngIf="showError('qualification')" class="text-danger">
				<span *ngIf="f.qualification.errors?.required">
					Required
				</span>
				<span *ngIf="f.qualification.errors?.incorrect">
					{{customError.qualification}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('consultation_charges')}"
					id="consultation_charges" formControlName="consultation_charges" placeholder="">
				<label>Consultation Charges</label>
			</div>
			<p *ngIf="showError('consultation_charges')" class="text-danger">
				<span *ngIf="f.consultation_charges.errors?.required">
					Required
				</span>
				<span *ngIf="f.consultation_charges.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.consultation_charges.errors?.incorrect">
					{{customError.consultation_charges}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<ng-select [ngClass]="{'is-invalid':showError('hospitals')}" [items]="hospitalList" bindLabel="name"
				bindValue="id" [clearable]="true" [multiple]="true" id="hospitals" formControlName="hospitals"
				placeholder="Hospital*" [appearance]="'outline'">
			</ng-select>
			<p *ngIf="showError('hospitals')" class="text-danger">
				<span *ngIf="f.hospitals.errors?.required">
					Required
				</span>
				<span *ngIf="f.hospitals.errors?.incorrect">
					{{customError.hospitals}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<p class="text-center">
				<strong>Drop signature here</strong>
			</p>
			<!-- <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="onFileSelect1($event)" [multiple]="false">
				<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
					<div class="text-center">
						<label>Drop signature here</label>
						<br />
						<label>OR</label>
						<br />
						<button type="button" class="btn btn-primary btn-sm" (click)="openFileSelector()">
							Browse Files
						</button>
					</div>
				</ng-template>
			</ngx-file-drop>
			<p *ngFor="let msg of fileMsg1" class="text-center" [ngClass]="msg.isInvalid?'text-danger':''">
				<span>
					{{msg.msg}}
				</span>
			</p> -->
			<app-file-upload [allowedFiles]="allowedLogoFiles" (selected)="onFileSelect1($event)" [upload]="false">
			</app-file-upload>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<p class="text-center">
				<strong>Drop stamp here</strong>
			</p>
			<app-file-upload [allowedFiles]="allowedLogoFiles" (selected)="onFileSelect2($event)" [upload]="false">
			</app-file-upload>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<p class="text-center">
				<strong>Drop stamp with signature here</strong>
			</p>
			<app-file-upload [allowedFiles]="allowedLogoFiles" (selected)="onFileSelect3($event)" [upload]="false">
			</app-file-upload>
		</div>
	</div>
	<div *ngIf="docDetails" class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
			<img *ngIf="docDetails.stamp" [src]="File_Storage_URL+docDetails.stamp" class="stamp" />
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
			<img *ngIf="docDetails.signature" [src]="File_Storage_URL+docDetails.signature" class="stamp" />
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
			<img *ngIf="docDetails.stamp_with_signature" [src]="File_Storage_URL+docDetails.stamp_with_signature"
				class="stamp" />
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}